<template>
  <b-card>
    <b-card-title>Re-Assign driver</b-card-title>
    <b-row>
      <b-col md="9">
        <v-select
          v-model="selectedDriver"
          placeholder="Select Driver"
          :options="nearDrivers"
          :loading="fetching"
          :get-option-label="(option) => `${option.phone_number} / Acceptance Ratio: ${option.acceptance_ratio}`"
        />
      </b-col>
      <b-col md="3">
        <b-button
          :disabled="!selectedDriver || assigning"
          variant="primary"
          @click="assignHandler"
        >
          <b-spinner
            v-if="assigning"
            small
          />
          <span v-else>Assign</span>
        </b-button>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import { ref } from '@vue/composition-api'
import {
  BCard, BCardTitle, BRow, BCol, BButton, BSpinner,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import axiosIns from '@/libs/axios'
import { errorNotification, successNotification } from '@/utils/toast-notifications'

export default {
  components: {
    BCard,
    BSpinner,
    BCardTitle,
    vSelect,
    BButton,
    BRow,
    BCol,
  },
  props: {
    booking: {
      type: Object,
      default: () => ({}),
    },
  },
  setup(props, ctx) {
    const { pickup, service } = props.booking
    const getNearestDriverData = {
      pickupLat: pickup.lat,
      pickupLng: pickup.lon,
      serviceName: service.name,
      serviceClass: service.class,
    }
    const nearDrivers = ref([])
    const fetching = ref(false)
    const selectedDriver = ref()
    const getNearestDriver = async () => {
      fetching.value = true
      const res = await axiosIns.get('drivers/nearest-driver', {
        params: getNearestDriverData,
      })
      const { data } = res.data
      nearDrivers.value = data
      fetching.value = false
    }
    getNearestDriver()

    const assigning = ref(false)
    const assignHandler = async () => {
      const body = {
        driver: selectedDriver.value,
      }
      try {
        assigning.value = true
        await axiosIns.patch(`/booking/update/${props.booking.id}`, body)
        successNotification('Assigned Successfully')
        ctx.emit('re-assigned')
      } catch (error) {
        const { error_message: errMsg } = error.response.data
        errorNotification(errMsg || 'An error occured while re-assigning')
      } finally {
        assigning.value = false
      }
    }
    return {
      nearDrivers,
      assignHandler,
      selectedDriver,
      assigning,
      fetching,
    }
  },
}
</script>
